export const environment = {
  production: false,
  urlSAS: "https://app-sas.omintseguros.com.br/api/SASData/Get_V2",

  consultaPaises: "SASVJ0005",
  getCotizacionDolar:"SASVJ0010",
  consultaQuantidadePassageiros: "SASVJ0009",
  consultaEstados: "SASVJ0004",
  consultaCEP: "SASVJ0011",

  OS: {
    nombre: "titulo",
    formasPagamento:"SASVJOS126",
    fazerCotacao: "SASVJOS115",
    getAccountData:"SASVJOS114",
    getToken: "SASVJ0123", 
    getSessionID: "SASVJ0045",
    emitir: "SASVJOS29A",
    getCupom: "SASVJOS105"
  },

  PA: {
    nombre: "titulo",
    formasPagamento:"SASVJPA126",
    fazerCotacao: "SASVJPA115",
    getAccountData:"SASVJPA114",
    getToken: "SASVJ0124", 
    getSessionID: "SASVJPA45",
    emitir: "SASVJPA29A" ,
    getCupom: "SASVJPA105"
  }
};
